import { useEffect } from 'react';

const ResourcePreloader: React.FC = () => {
  useEffect(() => {
    // Preload critical images
    const criticalImages = ['/herobg.png', '/quixly.svg', '/automation.png'];

    criticalImages.forEach(src => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = src;
      link.fetchPriority = 'high';
      document.head.appendChild(link);
    });

    // Cleanup function
    return () => {
      const preloadLinks = document.querySelectorAll('link[rel="preload"][as="image"]');
      preloadLinks.forEach(link => link.remove());
    };
  }, []);

  return null;
};

export default ResourcePreloader;
